module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('container', [_c('h1', {
    staticStyle: {
      "font-size": "25px",
      "margin-bottom": "30px",
      "text-align": "center"
    }
  }, [_vm._v("AR & TD")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('date-range-field', {
    model: {
      value: (_vm.rangeData),
      callback: function($$v) {
        _vm.rangeData = $$v
      },
      expression: "rangeData"
    }
  }), _vm._v(" "), _c('div', [_c('span', [_vm._v("Sort By : ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sortBy),
      expression: "sortBy"
    }],
    staticClass: "sortBySelect",
    attrs: {
      "name": "sortBy"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sortBy = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.sortByChangeHandle]
    }
  }, [_c('option', {
    attrs: {
      "value": "Distance"
    }
  }, [_vm._v("Total Distance")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Sessions"
    }
  }, [_vm._v("# of Sessions")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "ar-td-table"
  }, [_c('v-table', {
    staticStyle: {
      "width": "100%",
      "font-size": "11px"
    },
    attrs: {
      "is-loading": _vm.loading,
      "columns": _vm.columns,
      "is-horizontal-resize": "",
      "table-data": _vm.tableData,
      "show-vertical-border": true,
      "title-row-height": 30,
      "border": 1,
      "paging-index": (_vm.pageIndex) * _vm.pageSize,
      "footer": _vm.footer,
      "footer-row-height": 40,
      "footer-cell-class-name": _vm.setFooterCellClass
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt20 mb20 bold",
    staticStyle: {
      "padding-top": "25px"
    }
  }, [_c('v-pagination', {
    attrs: {
      "total": _vm.pageTotal,
      "page-size": _vm.pageSize,
      "layout": ['total', 'prev', 'pager', 'next', 'sizer', 'jumper']
    },
    on: {
      "page-change": _vm.pageChange,
      "page-size-change": _vm.pageSizeChange
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6271f581"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/AR&TD.vue
// module id = 1690
// module chunks = 1